import React from 'react'
import Second from '../../components/Second'

const secondPage = () => {
  return (
    <> 
       < Second />
    </>
  )
}

export default secondPage